module.exports = __webpack_public_path__ + "static/media/Geweih.50985eaa.svg";